import React, { useMemo } from 'react';
import * as styles from './Features.module.scss';
const Features = ({
  items
}) => {
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  const marqueeItems = useMemo(() => {
    if (!(items !== null && items !== void 0 && items.length)) {
      return [];
    }
    const minimumItems = Math.max(items.length * 2, 24);
    const repetitions = Math.ceil(minimumItems / items.length);
    return Array.from({
      length: repetitions
    }, () => items).flat().slice(0, minimumItems);
  }, [items]);
  const renderSequence = (sourceItems, prefix, includeTrailingSeparator = false) => sourceItems.flatMap((item, index) => {
    const nodes = [/*#__PURE__*/React.createElement("li", {
      key: `${prefix}-item-${index}`,
      className: styles.rootItem
    }, item)];
    const isLast = index === items.length - 1;
    if (!isLast || includeTrailingSeparator) {
      nodes.push(/*#__PURE__*/React.createElement("li", {
        key: `${prefix}-separator-${index}`,
        className: styles.rootSeparator,
        "aria-hidden": "true"
      }));
    }
    return nodes;
  });
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootTicker
  }, /*#__PURE__*/React.createElement("ul", {
    className: `${styles.rootList} ${styles.rootListDesktop}`
  }, renderSequence(items, 'desktop')), /*#__PURE__*/React.createElement("div", {
    className: styles.rootMarquee
  }, /*#__PURE__*/React.createElement("ul", {
    className: `${styles.rootList} ${styles.rootListTicker}`
  }, renderSequence(marqueeItems, 'marquee-primary', true)), /*#__PURE__*/React.createElement("ul", {
    className: `${styles.rootList} ${styles.rootListTicker}`,
    "aria-hidden": "true"
  }, renderSequence(marqueeItems, 'marquee-secondary', true)))));
};
export default Features;